import Ura from './Ura.json';
// eslint-disable-next-line
const ura = {...Ura}

export default ura;
